import React, { useCallback, useMemo, useState } from 'react';

import OpencareRewardsModal from 'pages/results/components/OpencareRewardsModal/OpencareRewardsModal';
import { useOfferService } from 'services/OfferService';

import {
  Container,
  ContentWrapper,
  GiftIcon,
  OfferText,
  SeeHowButton,
  Wrapper,
} from './OfferBanner-styled-components';

export const OfferBanner = () => {
  const { formattedReferralOfferName, offerName, isThirdPartyOffer } = useOfferService();
  const offerNameText = useMemo(() => formattedReferralOfferName || offerName, [formattedReferralOfferName, offerName]);

  const [opencareRewardsModalVisible, setOpencareRewardsModalVisible] = useState(false);
  const handleSeeHow = useCallback(() => setOpencareRewardsModalVisible(true), []);

  // The offer banner was performing worse, so we're hiding it until we can improve it
  return null;

  /* eslint-disable no-unreachable */
  return (
    <>
      <Wrapper>
        <Container>
          <ContentWrapper>
            <GiftIcon />
            <OfferText>{offerNameText}</OfferText>
          </ContentWrapper>
          <SeeHowButton onClick={handleSeeHow}>
            See How
          </SeeHowButton>
        </Container>
      </Wrapper>

      <OpencareRewardsModal
        offerName={offerName}
        isThirdPartyOffer={isThirdPartyOffer}
        opencareRewardsModalVisible={opencareRewardsModalVisible}
        setOpencareRewardsModalVisible={setOpencareRewardsModalVisible}
      />
    </>
  );
  /* eslint-enable no-unreachable */
};
